<template>
  <div>
    <div class="standart-page">
      <div class="row">
        <div class="col"></div>
        <div class="col"><h3 class="title">REPERTUVAR BİLDİRİMLERİ</h3></div>
        <div class="col d-flex justify-content-end align-items-start">
          <Can I="create" a="/repertuvar-bildirim/RepertuvarBildirim">
            <button class="btn btn-danger ml-2" v-for="(item,index) in $store.state.auth.user.mevcutBildirimTipleri" :key="index" @click="$router.push('repertuvar-bildirimi/detay/0/' + item.id)"><font-awesome-icon icon="plus" size="lg"></font-awesome-icon> Yeni {{ item.name }} Bildirimi</button>
          </Can>
        </div>
      </div>
      <div class="card-component mb-5">
        <div class="body">
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                  <label>Kayıt ID</label>
                  <input type="text" class="form-control" v-model="form.recordId" maxlength="7">
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                  <label>Başlık</label>
                  <input type="text" class="form-control" v-model="form.bildirimBaslik" maxlength="256">
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label>Bildirim Tipi</label>
                <select v-select class="form-control" v-model="form.bildirimTipi">
                    <option :value="0">Seçiniz</option>
                    <option :value="item.id"
                            v-for="(item,index) in $store.state.auth.user.mevcutBildirimTipleri" :key="index">
                            {{ item.name }}
                    </option>
                </select>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label>Bildirim Durumu</label>
                <select v-select class="form-control" v-model="form.kayitBildirimDurumu">
                    <option :value="0">Seçiniz</option>
                    <option :value="item.id"
                            v-for="(item,index) in $store.state.general.parameters.kayitBildirimDurumu" :key="index">
                            {{ item.name }}
                    </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3" v-if="$store.state.auth.user.mbId === 0">
              <div class="form-group">
                <label>Meslek Birliği</label>
                <select v-select
                    class="form-control"
                    v-model="form.mbId">
                  <option :value="0">Seçiniz</option>
                  <option :value="item.id"
                      v-for="(item,index) in mblist"
                      :key="index">
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="footer d-flex justify-content-end">
          <button class="btn btn-outline-secondary mt-4" @click="clear">Temizle</button>
          <button class="btn btn-secondary mt-4" @click="search">Listele</button>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table table-hover" v-if="renderComponent">
          <thead>
            <tr>
              <th class="fit">Oluşturulma Tarihi</th>
              <th class="fit">Bildirim Durumu</th>
              <th>Bildirim Başlığı</th>
              <th>Eser Adı</th>
              <th>Kullanıcı Adı</th>
              <th class="fit" v-if="$store.state.auth.user.mbId === 0">Meslek Birliği</th>
              <th class="fit text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in $store.state.rb.repertuvarBildirimi.liste" :class="{ 'green': item.goruldu }" :key="index" class="cursor-pointer" @click="$router.push('/repertuvar-bildirimi/detay/' + item.recordId + '/' + item.bildirimTipi)">
              <td class="fit">{{ item.creationTime | moment("DD/MM/YYYY") }}</td>
              <td class="fit">{{ getOptionWithParams(item.kayitBildirimDurumu, "kayitBildirimDurumu") }}</td>
              <td>{{ item.bildirimBaslik }}</td>
              <td>{{ item.eserAdi }}</td>
              <td>{{ item.creationUserNameSurname }}</td>
              <td class="fit" v-if="$store.state.auth.user.mbId === 0">{{ item.mbName }}</td>
              <td class="fit text-right">
                <Can I="delete" a="/repertuvar-bildirim/RepertuvarBildirim">
                  <button class="btn btn-sm btn-outline-secondary" @click.stop="showDeleteModal(item)">
                    <font-awesome-icon icon="trash-alt" size="lg"></font-awesome-icon>
                  </button>
                </Can>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="alert alert-danger text-center" v-if="showError">{{ errorMessage }}</div>
      <div class="row" v-if="$store.state.rb.repertuvarBildirimi.liste.length > 0 && !showError">
        <div class="col">
          <i class="text-secondary">{{ $store.state.rb.repertuvarBildirimi.sayfalama.totalItems }} kayıttan {{ ((form.pageNum - 1) * form.pageSize) + 1 }} - {{ form.pageNum * form.pageSize }} arası gösterilmektedir</i>
        </div>
        <div class="col">
          <div class="row">
            <div class="col d-flex justify-content-end">
              <nav>
                <paginate v-if="$store.state.rb.repertuvarBildirimi.liste.length"
                          :page-count="$store.state.rb.repertuvarBildirimi.sayfalama.totalPages"
                          :click-handler="changePage"
                          :prev-text="'Önceki'"
                          :next-text="'Sonraki'"
                          :active-class="'active'"
                          :container-class="'pagination'"
                          v-model="form.pageNum">
                </paginate>
              </nav>
            </div>
            <div class="col-2">
              <select class="form-control" v-model="form.pageSize" @change="changeSize">
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions,mapGetters} from "vuex";
export default {
  
  components: { },  
  data() {
    return {
      renderComponent: true,
      prevRoute:null,
      errorMessage:'',
      showError: false,
      mblist:[],
      overlay: false,
      form: {
        recordId:"",
        mbId:this.$store.state.auth.user.mbId || 0,
        kayitBildirimDurumu:6,
        bildirimTipi:0,
        bildirimBaslik:"",
        pageNum: 1,
        pageSize: 25,
      }
    }
  },
  methods: {
    ...mapActions('general', ['showModal', 'errorHandling']),
    ...mapActions('uye', ['getMBList']),
    ...mapActions('rb', [ 'searchRepertuvarBildirimi' ]),
    forceRerender() {
        this.renderComponent = false;
        this.$nextTick(() => {
            this.renderComponent = true;
        });
    },
    clear() {
      this.$store.state.rb.repertuvarBildirimi = Object.assign({}, {
        liste: [],
        sayfalama: {}
      });
      this.form = {
        recordId:"",
        mbId:this.$store.state.auth.user.mbId || 0,
        kayitBildirimDurumu:0,
        bildirimTipi:0,
        bildirimBaslik:"",
        pageNum: 1,
        pageSize: 25,
      };
      this.$store.state.rb.duplicateForm = Object.assign({}, this.form);
      this.showError = false;
      this.$store.state.rb.searchList = true;
    },
    changeSize() {
      this.list();
    },
    changePage(pageNumber) {
      this.form.pageNum = pageNumber;
      this.list();
    },
    search(){
      this.form.pageNum = 1;
      this.list();
    },
    list() {
      this.$store.state.rb.repertuvarBildirimi.liste = [];
      if (this.isEmptyFilterForm()) {
        this.showError = true;
        this.errorMessage = this.getMessage(140);
        return;
      }
      
      this.$store.state.rb.duplicateForm = Object.assign({}, this.form);
      this.$store.state.general.showOverlay = true;
      this.showError = false;

      let data = {
        recordId:this.form.recordId === ""?0:this.form.recordId,
        mbId:this.form.mbId,
        kayitBildirimDurumu:this.form.kayitBildirimDurumu,
        bildirimTipi:this.form.bildirimTipi,
        bildirimBaslik:this.form.bildirimBaslik,
        pageNum: this.form.pageNum,
        pageSize: this.form.pageSize
      }
      
      this.searchRepertuvarBildirimi(data).then(res => {
        this.$store.state.general.showOverlay = false;
        if(res.errorCode !== 0 && res.errorCode !== 118){
          this.errorHandling(res);
          return;
        }
        if ((res.data && res.data.liste.length === 0) || !res.data) {
          this.showError = true;
          this.errorMessage = this.getMessage(118);
          this.$store.state.rb.searchList = true;
        }else{
          this.showError = false;
          this.errorMessage = "";
          this.$store.state.rb.searchList = true;
          this.$store.state.rb.repertuvarBildirimi.liste.forEach(element => {
            let mbCheck = this.mblist.filter(x => x.id === element.mbId);
            if(mbCheck.length > 0){
              element.mbName = mbCheck[0].name;
            }
            this.forceRerender();
          });
        }
      }).catch(() => {
        this.$store.state.general.showOverlay = false;
      });
    },
    getMBListOptions(){
      if(this.$store.state.auth.user.mbId !== 0)
        return;

      this.$store.state.general.showOverlay = true;
      this.getMBList().then(res => {
        if(res.errorCode == 0){
            this.mblist = res.data;
        }else{
            this.errorHandling(res);
        }
        this.$store.state.general.showOverlay = false;
      });
    },
    isEmptyFilterForm() {
      this.formTrimCheck(this.form);
      return (this.$store.state.auth.user.mbId !== 0 || this.form.mbId === 0)
        && this.form.kayitBildirimDurumu === 0
        && (this.form.bildirimTipi === 0)
        && this.form.bildirimBaslik === ""
        && this.form.recordId === "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created() {
    if(this.$store.state.auth.user.mevcutBildirimTipleri && this.$store.state.auth.user.mevcutBildirimTipleri.length === 1){
      let tip = this.$store.state.auth.user.mevcutBildirimTipleri[0];
      this.form.bildirimTipi = tip.id;
    }
    this.getMBListOptions();
  },
  watch: {},
  computed: {
    ...mapGetters('general', ['getMessage', 'getOptionWithParams', 'getFileLink', 'getLogAction', 'formTrimCheck'])
  }
};
</script>